/** Danh sách ngân hàng VN (mã phổ biến) — dùng chọn TK nhận lương / thanh toán */
export const VIETNAM_BANKS = [
  { value: "VCB", label: "Vietcombank - Ngân hàng Ngoại thương Việt Nam" },
  { value: "BIDV", label: "BIDV - Ngân hàng Đầu tư và Phát triển Việt Nam" },
  { value: "CTG", label: "VietinBank - Ngân hàng Công Thương Việt Nam" },
  { value: "TCB", label: "Techcombank - Ngân hàng Kỹ thương Việt Nam" },
  { value: "MB", label: "MBBank - Ngân hàng Quân đội" },
  { value: "VPB", label: "VPBank - Ngân hàng Thịnh vượng và Phát triển" },
  { value: "ACB", label: "ACB - Ngân hàng Á Châu" },
  { value: "TPB", label: "TPBank - Ngân hàng Tiên Phong" },
  { value: "HDB", label: "HDBank - Ngân hàng Phát triển TP.HCM" },
  { value: "VIB", label: "VIB - Ngân hàng Quốc tế" },
  { value: "SHB", label: "SHB - Ngân hàng Sài Gòn - Hà Nội" },
  { value: "STB", label: "Sacombank - Ngân hàng Sài Gòn Thương Tín" },
  { value: "MSB", label: "MSB - Ngân hàng Hàng Hải Việt Nam" },
  { value: "SEA", label: "SeABank - Ngân hàng Đông Nam Á" },
  { value: "OCB", label: "OCB - Ngân hàng Phương Đông" },
  { value: "LPB", label: "LPBank - Ngân hàng Lộc Phát Việt Nam" },
  { value: "ABB", label: "ABBANK - Ngân hàng An Bình" },
  { value: "VAB", label: "VietABank - Ngân hàng Việt Á" },
  { value: "NAB", label: "Nam A Bank - Ngân hàng Nam Á" },
  { value: "PGB", label: "PGBank - Ngân hàng Thịnh vượng và Phát triển" },
  { value: "EIB", label: "Eximbank - Ngân hàng Xuất Nhập khẩu Việt Nam" },
  { value: "VCCB", label: "BVBank - Ngân hàng Bản Việt" },
  { value: "PVB", label: "PVcomBank - Ngân hàng Đại chúng Việt Nam" },
  { value: "SCB", label: "SCB - Ngân hàng Sài Gòn" },
  { value: "KLB", label: "Kienlongbank - Ngân hàng Kiên Long" },
  { value: "BVB", label: "Baoviet Bank - Ngân hàng Bảo Việt" },
];

export function labelForBankCode(code) {
  if (!code) return "";
  const f = VIETNAM_BANKS.find((b) => b.value === code);
  return f ? f.label : code;
}
